import React, { FunctionComponent, useEffect, useState } from "react";

import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { push } from "connected-react-router";

import { ApplicationState } from "../../../store";
import { getTutorialVideosRequest } from "../../../store/onboarding/actions";
import { TutorialVideo } from "../../../store/onboarding/types";
import LoadingIndicator from "../../common/onboarding/LoadingIndicator";
import TutorialItem from "./TutorialItem";
import { Accordion, Modal } from "react-bootstrap";
import { useIntl } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

type DispatchProps = {
  getTutorialVideosRequest: () => any;
  push: (location: string) => any;
};

type StateProps = {
  tutorials: TutorialVideo[];
  isLoading: {
    getTutorialVideosRequest?: boolean;
  };
};

type OwnProps = {};

type Props = OwnProps & DispatchProps & StateProps;

const TutorialVideosPage: FunctionComponent<Props> = ({
  getTutorialVideosRequest,
  tutorials,
  isLoading,
}) => {
  const [activeKey, setActiveKey] = useState<string | undefined>(undefined);
  const [showModal, setShowModal] = useState<boolean>(false);

  const handleTutorialChange = (newActiveKey: string | null) => {
    setActiveKey(newActiveKey ?? undefined);
  };

  const handleTutorialModalOpen = () => {
    setShowModal(true);
  };

  const intl = useIntl();

  useEffect(() => {
    getTutorialVideosRequest();
  }, []);

  return (
    <div className="dataContainer">
      <h2 className="font-weight-bold mb-2">
        {intl.formatMessage({
          id: "app.dashboard.tutorials.videos.title",
        })}
      </h2>
      <h4 >
        {intl.formatMessage({
          id: "app.dashboard.tutorials.videos.info",
        })}
      </h4>
      <div className="my-3">
        <span className="alert alert-warning py-1 px-1">
          Videos may not reflect the latest updates. For recent changes, see the Release Notes page.
        </span>
      </div>
      <hr />
      {isLoading.getTutorialVideosRequest ? (
        <LoadingIndicator />
      ) : (
        <Accordion
          className="tutorialsAccordion"
          activeKey={activeKey}
          onSelect={handleTutorialChange}
        >
          {tutorials.map((tutorial) => (
            <TutorialItem
              tutorial={tutorial}
              key={`tutorial_${tutorial.id}`}
              activeKey={activeKey}
              handleTutorialModalOpen= {handleTutorialModalOpen}
            />
          ))}
        </Accordion>
      )}

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        animation={false}
        centered
        size="lg"
        backdropClassName={"customDarkModalBackdrop in"}
      >
        <Modal.Header
          closeButton
          className="purpleModalHeader"
        >
          <Modal.Title>ReadyCoach Data Upload Update</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-6">
              <h3 className="font-weight-bold mb-3 text-center">What’s New</h3>
              <ul>
                <li>Only <span className="font-weight-bold">District Admin</span> and <span className="font-weight-bold">Coach</span> accounts can upload data</li>
                <li>
                  Teacher account holders can no longer:
                  <ul>
                    <li>Upload reading or behavior data</li>
                    <li>Create or edit data periods</li>
                    <li>Add students individually or via roster</li>
                    <li>Create custom assessments</li>
                  </ul>
                </li>
              </ul>
            </div>
            <div className="col-6">
              <h3 className="font-weight-bold mb-3 text-center">Teachers Still Have Access To</h3>
              <ul>
                <li>View data uploaded by District Admins and Coaches</li>
                <li>Edit details for existing students in shared data periods</li>
                <li>Assign teacher/class information</li>
                <li>Use grouping tools (Auto & Manual)</li>
                <li>Run reports (Class Wide Need, Equity Benchmark, Benchmark Summaries)</li>
                <li>Apply filters & multi-sort</li>
              </ul>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

const mapStateToProps = ({ onboarding }: ApplicationState): StateProps => {
  return {
    tutorials: onboarding.tutorialVideos,
    isLoading: {
      getTutorialVideosRequest: onboarding.isLoading.getTutorialVideos,
    },
  };
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => {
  return bindActionCreators(
    {
      getTutorialVideosRequest: getTutorialVideosRequest,
      push: push,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(TutorialVideosPage);
